import React from 'react';
import { BASE_URL } from '../constants/routes';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Jumbotron } from './Jumbotron';
import { Features } from './sections/Features';
import { Contact } from './sections/Contact';
import { Teams } from './sections/Teams';
import { References } from './sections/References';
import { Deployments } from './sections/Deployments';
import { Partners } from './sections/Partners';
import { TrainingBanner } from './TrainingBanner';
import { showsIkemTraining } from '../helpers/showsIkemTraining';
import { usePageMeta } from '../helpers/usePageMeta';
import { DemoCta } from './DemoCta';
import { UseCaseBar } from './UseCaseBar';
import { UseCaseTabs } from './UseCaseTabs';
import { useUseCase } from '../helpers/useUseCase';
import { DEFAULT_USE_CASE, hasIkemTraining, USE_CASE_PATHS } from '../config/useCasesConfig';
import { localizedPath } from '../helpers/localizedPath';

export const Home: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();
  const useCase = useUseCase();
  const showTraining = showsIkemTraining(i18n.language) && hasIkemTraining(useCase);
  // The default use case is the plain home page, so '/clinical' is canonically '/'
  // ('/en/clinical' is '/en'); the other use cases are their own page in each language.
  const isDefault = useCase === DEFAULT_USE_CASE;
  const title = isDefault ? t('meta.title') : `slp.blue® — ${t(`useCases.items.${useCase}.pitch.title`)}`;
  const description = isDefault ? t('meta.description') : t(`useCases.items.${useCase}.pitch.lead`);
  const canonical = `${BASE_URL}${localizedPath(pathname, isDefault ? '/' : USE_CASE_PATHS[useCase])}`;
  usePageMeta({
    title,
    description,
    keywords: t('meta.keywords'),
    canonical,
    ogTitle: title,
    ogDescription: description,
    ogUrl: canonical,
  });

  return (
    <main>
      <Jumbotron />
      <UseCaseTabs />
      <UseCaseBar />
      {showTraining && <TrainingBanner />}
      <Features inverse />
      <DemoCta inverse />
      <Deployments inverse />
      <References />
      <DemoCta compact titleKey={'cta.referencesTitle'} />
      <Teams inverse />
      <Partners />
      <Contact inverse />
    </main>
  );
};
